// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment_root_3V8qQ","badges":"Comment_badges_2LAf4","controls":"Comment_controls_2hdvt","answer":"Comment_answer_3praj"};